export default function getWardrobeType(wardrobe) {
  const types = Object.values(wardrobe.types);
  const wardrobeType = types[types.length - 1];
  return wardrobeType;
}
